import {
  Component,
  OnInit,
  ViewChild,
  Output,
  EventEmitter,
  Renderer,
  ElementRef,
} from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { VolvoApiService } from "../../services/volvo-api.service";
import { Observable } from "rxjs";
import { HotelPageConfiguration } from "../../models/hotel-page-configuration";
import { FormControl, Validators, FormGroup } from "@angular/forms";
import { MatDialog } from "@angular/material/dialog";
import { BasicRegistrationComponent } from "../../blocks/registration/components/basic-registration/basic-registration.component";
import { FormFieldTextBox } from "../../models/form-field-textbox";
import { FormControlService } from "../../services/form-control.service";
import { Title } from '@angular/platform-browser';

@Component({
  selector: "app-hotel",
  templateUrl: "./hotel.component.html",
  styleUrls: ["./hotel.component.scss"],
})
export class HotelComponent implements OnInit {
  @ViewChild("pagecontent") pageContent: ElementRef;
  private Guid: string;
  public hotelPageConfig$: Observable<HotelPageConfiguration>;
  localStrings$: Observable<Array<any>>;
  regForm: FormGroup;
  accessCode: FormFieldTextBox;
  AdditionalFieldsFormID: number;
  ls: Array<any>;
  isInvalidAccessCode: boolean;
  hasRegistrationAccess = false;
  userRegForm: BasicRegistrationComponent;
  isHotelPromotion: boolean = true;
  promotionAlias: string;

  @Output() onOpenModal = new EventEmitter();

  constructor(
    private dialog: MatDialog,
    private route: ActivatedRoute,
    private volvoApi: VolvoApiService,
    private router: Router,
    private _fs: FormControlService,
    private renderer: Renderer,
    private titleService: Title
    // private metaService: Meta
  ) {}

  ngOnInit() {
    this.promotionAlias = this.route.snapshot.paramMap.get("promotionAlias");
    // console.log('PromotionAlias: ' + this.promotionAlias);

    this.hotelPageConfig$ = this.volvoApi.getHotelPageConfiguration(
      this.promotionAlias
    );
    // redirect to main site when page doesn't exist
    this.hotelPageConfig$.subscribe((r) => {
      this.AdditionalFieldsFormID = r.AdditionalFieldsFormID;
      if (!r.ID) {
        this.router.navigateByUrl("notfound");
      }

      this.Guid = r.Guid;
      const _pagetitle = r.PageTitle ? r.PageTitle : "Volvo Affinity Programs";
      this.titleService.setTitle(_pagetitle);

      // // Meta Tags - Primary
      // this.metaService.addTag({ name: 'title', content: _pagetitle });
      // this.metaService.addTag({ name: 'description', content: r.PageDescription });

      // // Meta Tags - Open Graph / Facebook
      // this.metaService.addTag({ property: 'og:type', content: 'website' });
      // this.metaService.addTag({ property: 'og:url', content: window.location.href });
      // this.metaService.addTag({ property: 'og:title', content: _pagetitle });
      // this.metaService.addTag({ property: 'og:description', content: r.PageDescription });
      // this.metaService.addTag({ property: 'og:image', content: r.PageMetaImg });
      
      // // Meta Tags - Twitter
      // this.metaService.addTag({ property: 'twitter:card', content: 'summary_large_image' });
      // this.metaService.addTag({ property: 'twitter:url', content: window.location.href });
      // this.metaService.addTag({ property: 'twitter:title', content: _pagetitle });
      // this.metaService.addTag({ property: 'twitter:description', content: r.PageDescription });
      // this.metaService.addTag({ property: 'twitter:image', content: r.PageMetaImg });

    });

    this.localStrings$ = this.volvoApi.getPromotionLocalizationString();
    this.localStrings$.subscribe((p) => {
      this.ls = p;
      this.createFormControls();
      this.createForm();
    });
  }

  showRegistrationForm() {
    const accessCode = this.regForm.get("accessCode").value;
    const user = this.volvoApi.getUser(accessCode);

    user.subscribe((r) => {
      if (r != null) {
        this.isInvalidAccessCode = false;
        this.hasRegistrationAccess = true;
      } else {
        this.isInvalidAccessCode = true;
        this.hasRegistrationAccess = false;
        return false;
      }
    });
  }

  createFormControls() {
    this.accessCode = this._fs.createTextBox(
      "accessCode",
      this.ls["AV.HotelPromotion.lb.AccessCode"],
      null,
      null,
      null,
      this.ls["AV.HotelPromotion.lb.validation.AccessCode"],
      this.ls["AV.Promotions.lb.validation.AccessCode.invalid"],
      [Validators.required]
    );
  }

  createForm() {
    const group: any = {};
    group[this.accessCode.key] = new FormControl(
      this.accessCode.value || "",
      this.accessCode.validators || null
    );

    this.regForm = new FormGroup(group);
  }

  skipToContent() {
    this.renderer.invokeElementMethod(this.pageContent.nativeElement, "focus");
  }
}
